export const CCLS_MODULE = '/cclsmodule/' as const
export const CCLS_MODULE_ALL = `${CCLS_MODULE}all` as const
export const CCLS_MODULE_TEACHER = `${CCLS_MODULE}teachers/` as const
